import { Injectable } from "@angular/core";

/** hd-detail-form 字段展示类型 */
export enum HdDetailFormFieldType {
  /** 普通文本（默认） */
  Text = "text",
  /** 附件图片（描述项内横排缩略图） */
  Accessory = "accessory",
}

/** 附件图片项（path 为图片地址） */
export interface HdDetailFormImage {
  name?: string;
  path?: string;
  url?: string;
}

@Injectable({
  providedIn: "root",
})
export class HdDetailFormService {
  constructor() {}
}
